import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import Navbar from '../components/Navbar';
import {
  VISIT_PURPOSE_LIST_API,
  VISIT_PURPOSE_ADD_API,
  VISIT_PURPOSE_TOGGLE_API
} from '../utils/api';

export default function VisitPurposes() {
  const [purposes, setPurposes] = useState([]);
  const [purposeName, setPurposeName] = useState('');
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem('token');
  const decoded = JSON.parse(atob(token));
  const customer_id = decoded.customer_id;

  useEffect(() => {
    fetchPurposes();
  }, []);

  const fetchPurposes = async () => {
    try {
      const res = await axios.post(VISIT_PURPOSE_LIST_API, { token, customer_id });
      if (res.data.success) {
        setPurposes(res.data.purposes);
      } else {
        toast.error(res.data.message || 'Failed to load purposes');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error loading purposes');
    }
  };

  const handleAdd = async () => {
    if (!purposeName.trim()) return toast.error('Purpose name is required');
    try {
      setLoading(true);
      const res = await axios.post(VISIT_PURPOSE_ADD_API, { token, customer_id, name: purposeName });
      if (res.data.success) {
        toast.success('Visit purpose added');
        setPurposeName('');
        fetchPurposes();
      } else {
        toast.error(res.data.message || 'Failed to add');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error adding purpose');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (id) => {
    try {
      const res = await axios.post(VISIT_PURPOSE_TOGGLE_API, { token, id });
      if (res.data.success) {
        toast.success('Status updated');
        fetchPurposes();
      } else {
        toast.error(res.data.message || 'Failed to update');
      }
    } catch (err) {
      console.error(err);
      toast.error('Error toggling status');
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <h4 className="mb-4">🎯 Visit Purposes</h4>

        <div className="row g-2 mb-4">
          <div className="col-md-6">
            <input
              type="text"
              className="form-control"
              placeholder="Enter purpose of visit"
              value={purposeName}
              onChange={(e) => setPurposeName(e.target.value)}
            />
          </div>
          <div className="col-auto">
            <button className="btn btn-primary" onClick={handleAdd} disabled={loading}>
              {loading ? 'Saving...' : 'Add Purpose'}
            </button>
          </div>
        </div>

        <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Purpose Name</th>
              <th>Status</th>
              <th>Toggle</th>
            </tr>
          </thead>
          <tbody>
            {purposes.length === 0 && (
              <tr><td colSpan="4" className="text-center text-muted">No purposes found</td></tr>
            )}
            {purposes.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.purpose_name}</td>
                <td>
                  <span className={`badge ${item.status === 1 ? 'bg-success' : 'bg-secondary'}`}>
                    {item.status === 1 ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td>
                  <button className="btn btn-sm btn-outline-warning" onClick={() => handleToggleStatus(item.id)}>Toggle</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
